"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HomepageSplitMarquee;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _panel = require("./panel");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
/* eslint-disable no-nested-ternary */

const HomepageSplitMarqueeWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HomepageSplitMarqueeWrapper",
  class: "pl-h4o5vew",
  vars: {
    "h4o5vew-0": [({
      layout,
      reverseOnMobile
    }) => layout === 'secondary-primary' ? reverseOnMobile ? `'primary' 'secondary'` : `'secondary' 'primary'` : reverseOnMobile ? `'secondary' 'primary'` : `'primary' 'secondary'`],
    "h4o5vew-2": [({
      layout
    }) => layout === 'secondary-primary' ? `'secondary primary'` : `'primary secondary'`],
    "h4o5vew-3": [({
      layout
    }) => layout === 'secondary-primary' ? '28% auto' : 'auto 28%']
  }
});

/**
 * Render Panel
 *
 * @param {Object} props React props for Panel
 * @param {string} props.marqueeLayout Marquee layout
 * @param {string} props.panel Panel's horizontal alignment in the marquee
 * @param {object} props.primaryPanel Marquee's Primary Panel
 * @param {object} props.secondaryPanel Marquee's Secondary Panel
 * @returns {React.ReactElement} Panel
 * @public
 */
const Panel = ({
  marqueeLayout,
  primaryPanel,
  secondaryPanel,
  panel
}) => {
  if (marqueeLayout === 'primary-secondary' && panel === 'start' || marqueeLayout === 'secondary-primary' && panel === 'end') {
    return /*#__PURE__*/_react.default.createElement(_panel.PrimaryPanel, primaryPanel);
  }
  return /*#__PURE__*/_react.default.createElement(_panel.SecondaryPanel, secondaryPanel);
};
Panel.propTypes = {
  marqueeLayout: _propTypes.default.oneOf(['primary-secondary', 'secondary-primary']).isRequired,
  primaryPanel: _propTypes.default.shape({
    ..._panel.PrimaryPanel.propTypes
  }).isRequired,
  secondaryPanel: _propTypes.default.shape({
    ..._panel.SecondaryPanel.propTypes
  }).isRequired,
  panel: _propTypes.default.oneOf(['start', 'end'])
};

/**
 * Render HomepageSplitMarquee
 *
 * @param {Object} props React props for Homepage Split Marquee
 * @param {string} props.marqueeLayout Marquee layout
 * @param {object} props.primaryPanel Marquee's Primary Panel
 * @param {object} props.secondaryPanel Marquee's Secondary Panel
 * @param {boolean} props.reverseMobileLayout Reverses marquee layout on mobile and tablet
 * @returns {React.ReactElement} Homepage Split Marquee
 * @public
 */
function HomepageSplitMarquee({
  marqueeLayout = 'primary-secondary',
  primaryPanel,
  secondaryPanel,
  reverseMobileLayout = false,
  partial = ''
}) {
  return /*#__PURE__*/_react.default.createElement(HomepageSplitMarqueeWrapper, {
    "data-partial": partial,
    layout: marqueeLayout,
    reverseOnMobile: reverseMobileLayout,
    className: "legacy-container",
    "data-cy": marqueeLayout === 'primary-secondary' ? 'hp-marquee-primary' : 'hp-marquee-secondary'
  }, /*#__PURE__*/_react.default.createElement(Panel, {
    panel: "start",
    marqueeLayout: marqueeLayout,
    primaryPanel: primaryPanel,
    secondaryPanel: secondaryPanel
  }), /*#__PURE__*/_react.default.createElement(Panel, {
    panel: "end",
    marqueeLayout: marqueeLayout,
    primaryPanel: primaryPanel,
    secondaryPanel: secondaryPanel
  }));
}
HomepageSplitMarquee.propTypes = {
  marqueeLayout: _propTypes.default.oneOf(['primary-secondary', 'secondary-primary']).isRequired,
  primaryPanel: _propTypes.default.shape({
    ..._panel.PrimaryPanel.propTypes
  }).isRequired,
  secondaryPanel: _propTypes.default.shape({
    ..._panel.SecondaryPanel.propTypes
  }).isRequired,
  reverseMobileLayout: _propTypes.default.bool,
  partial: _propTypes.default.string
};